import { defineStore } from 'pinia'
import { TabsStore } from '@/store/modules/tabs'
import useStoreStore from '@/store/modules/store'
import avatarImg from '@/assets/images/useravatar.png'

export interface IUserInfo {
  name: string
  avatar: string
  userCode: string
  token: string
  email: string
  phone: string
  isSuperAdmin: number
  platform: string
  country: string
}

const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {
      userName:
        JSON.parse(localStorage.getItem('userInfo') || '{}')?.userName || '',
      userCode: '',
      token: '',
      email: JSON.parse(localStorage.getItem('userInfo') || '{}')?.email || '',
      isSuperAdmin: 0,
      country: null,
      avatar: avatarImg,
      platform: null
    },
    verified: false
  }),
  getters: {},
  actions: {
    setUserInfo(userData: any) {
      this.userInfo = {
        ...userData,
        avatar:
          'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
        platform: userData.platform || null
      }
    },
    getToken() {
      let token: string = this.userInfo?.token || ''
      if (token.length < 1) {
        token =
          JSON.parse(localStorage.getItem('userInfo') || '{}')?.token || ''
      }
      return token
    },
    //获取绑定平台
    getUserPlatform() {
      let platform: string = this.userInfo?.platform || ''
      if (platform.length < 1) {
        platform =
          JSON.parse(localStorage.getItem('userInfo') || '{}')?.platform || ''
      }
      return platform
    },
    updateUserVerified(verified: boolean) {
      this.verified = verified
    },
    logout() {
      const tabsStore = TabsStore()
      const storeStore = useStoreStore()

      localStorage.removeItem('userInfo')
      tabsStore.closeAll()
      storeStore.clearStores()
      // 清除所有以 _&_ 开头的 localStorage
      Object.keys(localStorage).forEach((key) => {
        if (key.startsWith('_&_')) {
          localStorage.removeItem(key)
        }
      })
    }
  },
  persist: true
})

export default useUserStore
